import { useRef, useState, useEffect } from 'react';
import * as React from 'react';
import styled from 'styled-components';
import View from '@sdk/components/primitives/View';
import { MAIN_NAVIGATION_HEIGHT } from '@sdk/common/constants';
import NavigationHeader, { NavigationOption } from '@sdk/components/ui/NavigationHeader';

import { TabType } from '../types';
import { useSettingsErrorsContext } from '../SettingsErrorContext';

const ObserverSpot = styled(View)`
  height: 1px;
`;

type Props = {
  tabs: NavigationOption[];
  getIndexTab?: boolean;
  initialTab?: string;
  maxContentWidth?: number;
  onTabChange: (prop: any) => void;
};

const SettingsNavigation: React.FC<React.PropsWithChildren<Props>> = ({
  tabs,
  onTabChange,
  initialTab,
  maxContentWidth,
}) => {
  const { isTabValid } = useSettingsErrorsContext();
  const navigationErrorsHandler = (tabs: NavigationOption[]): NavigationOption[] => {
    return tabs
      .filter((tab) => Boolean(tab.show?.()))
      .map((tab) =>
        isTabValid(TabType[tab.value]) ? { ...tab, hasError: false } : { ...tab, hasError: true }
      );
  };

  const [isSticky, setIsSticky] = useState(false);
  const ref = useRef();

  /**
   * This IntersectionObserver method was used for detecting when the  was fixed in css as position sticky
   */
  useEffect(() => {
    const cachedRef = ref?.current,
      observer = new IntersectionObserver(([e]) => setIsSticky(e.intersectionRatio < 1), {
        rootMargin: `-${MAIN_NAVIGATION_HEIGHT}px`,
        threshold: [0],
      });

    observer.observe(cachedRef);

    return function (): void {
      observer.unobserve(cachedRef);
    };
  }, []);

  return (
    <>
      <ObserverSpot ref={ref} />
      <NavigationHeader
        options={navigationErrorsHandler(tabs)}
        onTabChange={onTabChange}
        getIndexTab
        initialTab={initialTab}
        maxContentWidth={maxContentWidth}
        sticky={isSticky}
      />
    </>
  );
};

export default SettingsNavigation;
